export default __webpack_public_path__ + "static/media/cart-remove.66f91687.svg";